<template>
    <span class="text-danger" v-if="mostrarBtnExcluirAnexo">
        <i
            class="fa fa-trash fa-lg icon-button ml-2"
            title="Excluir anexo"
            @click.stop="confirmarExcluirAnexo()"
        ></i>
    </span>
</template>

<script>
import { consultoriaStatus } from '../../ConsultoriaStatus'

export default {
    props: {
        consultoriaAnexo: {
            type: Object,
            default: () => ({})
        },

        consultoria: {
            type: Object,
            default: () => ({})
        },

        servicos: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarExcluirAnexo() {
            this.$swal({
                title: 'Exclusão de Arquivo',
                html: `Confirma a exclusão do arquivo <b>${this.consultoriaAnexo.nomeArquivoOriginal}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.excluirConsultoriaAnexo()
                }
            })
        },

        excluirConsultoriaAnexo() {
            this.$store.dispatch('addRequest')
            this.servicos
                .excluirConsultoriaAnexo(
                    this.consultoriaAnexo.consultoriaAnexoId
                )
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Registro excluído com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterConsultoriaAtualizada')
                        } else {
                            this.$toast.error(
                                'Erro ao excluir anexo.',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    computed: {
        mostrarBtnExcluirAnexo() {
            return (
                this.$temAcesso('APPSE-FORN-CONS-02') &&
                (this.consultoria.status === consultoriaStatus.EM_ANDAMENTO ||
                    this.consultoria.status ===
                        consultoriaStatus.CONCLUIDA_PENDENTE_ANALISE ||
                    this.consultoria.status ===
                        consultoriaStatus.CONCLUIDA_PENDENTE_CORRECAO)
            )
        }
    }
}
</script>
